import vedeoGallery from '../js/components/video-gallery'

console.log('Входящий JS файл работает.');
import swiper from './vendor/swiper';
import gallerySlider from "./vendor/fansyapps";

